// extracted by mini-css-extract-plugin
export default {"Buttons":"styles_Buttons__trOc+","Center":"styles_Center__s6BN0","Card":"styles_Card__6326s"};